var _rect, _path, _rect2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconApplePay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 58 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 57,
    height: 39,
    rx: 5.5,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.008 13.906c-.493.586-1.28 1.049-2.068.983-.098-.793.287-1.636.739-2.156.492-.603 1.353-1.033 2.05-1.066.083.826-.237 1.636-.721 2.239zm.713 1.14c-.694-.04-1.327.21-1.838.412-.33.13-.608.24-.82.24-.238 0-.528-.116-.854-.246-.427-.171-.915-.366-1.426-.357-1.174.017-2.265.686-2.864 1.751-1.23 2.131-.32 5.287.87 7.022.582.859 1.28 1.8 2.199 1.768.404-.016.695-.14.995-.269.347-.148.707-.302 1.269-.302.542 0 .887.15 1.217.294.314.137.616.268 1.064.26.951-.017 1.55-.86 2.133-1.718a7.573 7.573 0 00.946-1.959l.005-.015a.217.217 0 00-.022-.011c-.21-.097-1.816-.838-1.832-2.823-.015-1.666 1.274-2.51 1.477-2.643a.713.713 0 00.025-.017c-.82-1.222-2.1-1.354-2.544-1.387zm6.588 10.482V12.65h4.8c2.477 0 4.208 1.718 4.208 4.23 0 2.51-1.764 4.245-4.274 4.245h-2.748v4.403h-1.986zm1.985-11.193h2.29c1.722 0 2.707.925 2.707 2.553 0 1.627-.985 2.56-2.716 2.56h-2.28v-5.113zm13.578 9.648c-.525 1.008-1.681 1.644-2.928 1.644-1.846 0-3.134-1.107-3.134-2.775 0-1.652 1.247-2.602 3.552-2.743l2.478-.149v-.71c0-1.049-.681-1.619-1.896-1.619-1 0-1.73.52-1.878 1.314h-1.789c.058-1.67 1.616-2.883 3.725-2.883 2.272 0 3.75 1.197 3.75 3.056v6.41h-1.839v-1.545h-.04zm-2.395.116c-1.059 0-1.731-.512-1.731-1.297 0-.81.648-1.28 1.886-1.355l2.207-.14v.727c0 1.206-1.017 2.065-2.362 2.065zm10.37 1.933c-.796 2.255-1.707 2.999-3.643 2.999-.148 0-.64-.017-.755-.05v-1.545c.123.017.427.033.583.033.878 0 1.37-.371 1.673-1.338l.18-.57-3.363-9.375h2.076l2.338 7.607h.041l2.338-7.607h2.018l-3.486 9.846z",
    fill: "#000"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 57,
    height: 39,
    rx: 5.5,
    stroke: "#F2F4F7"
  })));
}

export default SvgIconApplePay;